import { Text } from "components/Text/Text.component";
import styled, { css } from "styled-components";
import { colors } from "theme/colors";
import { RadioButtonProps, WrapperProps } from "./types";

export const Label = styled(Text)`
    ${({ disabled }) =>
        disabled &&
        css`
            color: ${colors.grey.primary} !important;
            cursor: not-allowed !important;
        `}
`;

export const Radio = styled.input<RadioButtonProps>`
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
    width: 1.5em;
    height: 1.5em;
    border: 6px solid ${colors.grey.tertiary2};
    cursor: pointer;
    border-radius: 50%;
    ::after {
        cursor: pointer;
        content: "";
        display: block;
        border-radius: 50%;
        width: 0.5em;
        height: 0.5em;
        margin: 3px;
    }
    &:checked {
        border-color: ${colors.purple.primary};
    }

    &:disabled {
        cursor: not-allowed;
    }
`;

export const Container = styled("label")<WrapperProps>`
    display: flex;
    gap: 0.5rem;
    align-items: center;
    cursor: pointer;
    width: ${({ fullWidth }) => fullWidth && "100%"};
    &:hover {
        ${Radio} {
            border-color: ${colors.purple.secondary};
            &:checked {
                border-color: ${colors.purple.primary};
            }
        }
    }
`;
